import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { APICallingService } from '../model/APICallingService';
import { UserSettings } from '../model/UserSettings';
import * as PageStore from "src/app/Store/PageStore/Page.Actions";
import Swal from 'sweetalert2';
import { AppSettings,IAppSettings } from '../model/application-settings';
import { HttpClient } from '@angular/common/http';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  email:any='';
  password:any='';
  passwordemail:any=[];
  forgotpasswordmodeldisplay='none';
  submit=false;
  constructor(private route: ActivatedRoute,private apiCall:APICallingService,private router:Router,private store: Store<any>,public appSettings:AppSettings,private http: HttpClient,) { }
  returnurl='/online-order/home';
  ngOnInit(): void {
    this.route.queryParamMap
    .subscribe((params:any) => {
      debugger;
      if( typeof(params.params.returnurl)!='undefined')
      {
     this.returnurl= params.params.returnurl;
      }
      //this.orderObj = { ...params.keys, ...params };
    });
  }

  storeSettings:IAppSettings=
  {
    faxUserId:'',
      faxPassword:'',
      companyName:'',
      theamColorCode:'#ea0029',
      headerColorCode: '#000',
      headerimage: '../../assets/img/trending1.png',
      loginBackgroundImage:'../../assets/img/logo_web.png',
      loginImage:'../../assets/img/logo_web.png',
      dangerColorCode: '#dc3545',
      successColorCode: '#28a745',
      logo: '../../assets/img/logo_web.png',
      paymentGateway:'',
      key:'',
      selectedBranch:'',
      apiLoginId:'',
      orderEmail:'',
      adminUrl:'',
      orderUrl:'',
      viewName:'AppSettings',
      apiCallingUrl:'',
      fontFamily:'prompt,sans-serif',
      domainName:'',
      fax:'',
      projectId:'',
      keyNo:'',
      noOfBranches:0,
      addClover:'',
      cloverAccessToken:'',
      cloverAuthToken:'',
      cloverMerchantId:'',
      cloverEmployeeID:'',
      cloverTenderId:'',
      currency:'',
      transactionkey:'',
  };

validateLogin():any
{
  var validate=true;
  var valEmail=this.validateEmail(this.email);
if((this.email==''|| (valEmail!=true))&& validate)
{


validate =false;

}

if(this.password=='' && validate)
{
validate =false;

}
return validate;
}
homeClick()
{
  this.router.navigateByUrl('/')
}
validateEmail(input:any):boolean
{



var regexp=new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  var res= regexp.test(input)

 return res;
}

submited=false;
loginClick()
{
  debugger;
  this.submited =true;

if(this.validateLogin())
{
  
this.login();

}

}
dbResult:any;
storeUserSettings:any;
login()
{
  debugger;
  this.storeUserSettings=new UserSettings;
  var Userresult = (this.store as any).source['value']['MSFOO'].filter((x:any) => { return x.viewName == "UserDetails"; });
  if (Userresult.length > 0) {
    this.storeUserSettings=( Userresult[0] );
  }
  this.storeUserSettings=new UserSettings();
  if(this.email!="" &&  this.password!="")
  {
    debugger;
    this.apiCall.DBCalling("UserLogin",this.email,this.password,"","").subscribe(
      (res:any) => 
      {
       debugger;
       // this.dbResult= (res);
       this.dbResult= (res);
      
       if(this.dbResult.tasks.length>0 )
       {
         let i=0;
  this.storeUserSettings.UserID=this.dbResult.tasks[i][0].UserID;
  this.storeUserSettings.Email=this.dbResult.tasks[i][0].Email;
  this.storeUserSettings.FirstName=this.dbResult.tasks[i][0].FirstName;
  this.storeUserSettings.LastName=this.dbResult.tasks[i][0].LastName;
  this.storeUserSettings.City=this.dbResult.tasks[i][0].City;
  this.storeUserSettings.State=this.dbResult.tasks[i][0].State;
  this.storeUserSettings.PinCode=this.dbResult.tasks[i][0].Zip;
  this.storeUserSettings.Country=this.dbResult.tasks[i][0].Country;
  this.storeUserSettings.Address=this.dbResult.tasks[i][0].Address;
  this.storeUserSettings.ProfileImage=this.dbResult.tasks[i][0].ProfileImage;
  this.storeUserSettings.Password=this.dbResult.tasks[i][0].Password;
  this.storeUserSettings.Mobile=this.dbResult.tasks[i][0].Mobile;
  this.storeUserSettings.UnReadNotificationCount=this.dbResult.tasks[0][0].UnReadNotificationCount;
  this.storeUserSettings.EmailVerified =this.dbResult.tasks[0][0].EmailVerified;
  this.storeUserSettings.viewName="UserDetails";
  this.store.dispatch(new  PageStore.OpenPage(this.storeUserSettings));
  this.router.navigate([this.returnurl])
  .then(() => {
    window.location.reload();
  });
       }else
       {
        Swal.fire({
          position: 'center',
          icon: 'error',
          text:'Invalid Details'
        });
         //alert("Invalid Login Details");
       }
       } );
  }
}
guestLoginClick(){
  
}

registrationClick(){
  this.router.navigateByUrl('/registration');
}
forgotPasswordClick(){
  debugger;
  this.submit = false;
  this.passwordemail = '';
  this.forgotpasswordmodeldisplay = 'block';
}

forgotPasswordModelClose(){
  this.forgotpasswordmodeldisplay = 'none';
}

  mailPassword:string="";
//  message = '<table height="40%" width="60%" align="" border="10" cellpadding="5" cellspacing="5" bgcolor="#FFCC99">'+
//  +'<thead><h4>Password for your email for login into Food Order Online.</h4></thead>'+
//   +'<tbody>'+
//     +'<tr>'+
//       +'<td width="38%" align="center" class="cntnt"><span class="style9">Email</span></td>'+
//       +'<td class="cntnt" width="9%" align="center">:</td>'+
//       +'<td width="53%" height="30">'+this.passwordemail+' </td>'+
//     +'</tr>'+
//     +'<tr>'+
//     +'<td class="cntnt" align="center"><span class="style9">Message</span></td>'+
//     +'<td class="cntnt" align="center">:</td>'+
//     +'<td height="30">'+this.passwordemail+' </td>'+
//     +'</tr>'+
//     +'</tbody>'+
//     +'</table>';

    viewandSaveForgotPassword(){
      debugger;
      this.submit = true;
      if(this.passwordemail!='' && this.passwordemail != this.validateEmail(this.passwordemail)){
      this.apiCall.DBCalling("ForgetPassword",this.passwordemail,"","","").subscribe(
        (res:any) => 
        {
         debugger;
         this.dbResult= (res);
         if(this.dbResult.tasks.length > 0){
          this.mailPassword = this.dbResult.tasks[0][0].Password;
          this.saveforgotPassword();
         }else{
          Swal.fire({
            position: 'center',
            icon: 'error',
            text:'Invalid Details'
          });
         }
    });
    }
    }

    name:string="";
saveforgotPassword(){
  debugger;
  this.submit = true;
  this.storeSettings = this.appSettings.loadSettings();
  var Message = "<html>"
  +"<body>"
  +"<div class='container' style='max-width: 1140px;margin-left: auto; margin-right: auto;'>"
  +"<section style='background: #f7d25a;padding: 55px;border-radius: 50px 50px 0px 0px;'>"
  +"<th style='width: 75%;'>"
  +"<h2 style='font-style: italic;font-size: 45px;text-shadow: rgb(0 0 0 / 21%) 0px 3px 32px;text-align:center'>Forgot Password</th>"
  +"</section>"
  +"<section>"
  +"<h4 style='margin: 15px; font-family: sans-serif;text-align:center'>"+this.storeSettings.companyName+"</h4>"
  +"<p style='margin: 15px; font-family: sans-serif;line-height: 25px;text-align:center'>Use these password and Login into "+this.storeSettings.companyName+" and start using.</p><br>"
  +"<h4 style='margin: 15px; font-family: sans-serif;line-height: 25px;border-top:1px dashed black;text-align:center'>Your Password</h4><br>"
  +"<p style='margin: 0px; margin-left: 15px;font-family: sans-serif;line-height: 25px;text-align:center;line-height: 25px;'>"+this.mailPassword+"</p></section><br>"
  +"<section>"
  +"<p style='margin: 0px; margin-left: 15px;font-family: sans-serif; line-height: 35px;'>Thanks For Using "+this.storeSettings.companyName+"! We Appreciate That You've Choosen Us.</p>"
  +"<p style='margin: 0px; margin-left: 15px;font-family: sans-serif; line-height: 35px;'><strong>Thanks.</strong></p>"
  +"</section>"
  +"</div>"
  +"</body>"
  +"</html>"
  if(this.passwordemail!='' && this.passwordemail != this.validateEmail(this.passwordemail)){
    this.apiCall.resetPasswordEmail('name',this.passwordemail,"Forgot Password for "+this.storeSettings.companyName+"",Message,this.storeSettings.companyName,this.storeSettings.faxUserId,this.storeSettings.faxPassword,this.storeSettings.fax).subscribe((res: any) => {
      debugger;
      this.dbResult= (res);
      if(this.dbResult.length>0){
        Swal.fire({
          position: 'center',
          icon: 'success',
          text:'email sent successfully'
        });
        this.forgotpasswordmodeldisplay = 'none';
      }
      console.log(res);
    });
  //   debugger;
  //  // var data = JSON.stringify({'Name':'qwerty' ,'Email':this.passwordemail ,'Subject':'Request for password', 'Message':Message,'companyName':this.storeSettings.companyName});
  //   this.http.post('https://mechknowsamplework.com/HyderabadUS/HyderabadUSAdminWebAPI/ApplicationLevelScripts/Email.php', {'Name':'qwerty' ,'Email':this.passwordemail , 'Message':'hi food orderonline'}).subscribe((res) => {
  //     debugger;
  //     console.log(res);
  //    })
  }
}

}
